/**
 * Created by shamim.ahsan on 10/24/2018.
 */
import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';


import {of, Observable} from 'rxjs';
import {catchError, concatMap, map, mergeMap, switchMap} from 'rxjs/operators';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import { TreatyApiService } from '../../services/treaty.service';
import { CommandService } from '@core/services/command.service';
import { SmartGridService } from '@core/services/smart-grid.service';
import { FileManagementService } from '@core/services/file-management.service';
import { SnackBarService } from '@core/services/snack-bar.service';
import {
  CreateTreatyAction,
  GET_OTHER_DOCUMENT_INFO, GetOtherDocumentInfoFailAction, GetOtherDocumentInfoSuccessAction,
  TreatyActions
} from "../actions/treaty.actions";


@Injectable()
export class TreatyEffect {
  constructor(private actions$: Actions,
              private commandParticleService: CommandService,
              private smartGridService: SmartGridService,
              private treatyApiService: TreatyApiService,
              private snackBarService: SnackBarService,
              private fileManagementService: FileManagementService,
              private fuseSplashScreenService: FuseSplashScreenService) {

  }


  getOtherDocument$ = createEffect(() => this.actions$.pipe(
    ofType(GET_OTHER_DOCUMENT_INFO),
    mergeMap((action: CreateTreatyAction) => {
      this.fuseSplashScreenService.show();
      return this.treatyApiService.getOtherDocumentInfo().pipe(
        map((payload) => {
          console.log("Received payload", payload);
          return new GetOtherDocumentInfoSuccessAction(payload);
        }),
        catchError(err => {
          this.snackBarService.showError(err.error);
          this.fuseSplashScreenService.hide();
          return of(new GetOtherDocumentInfoFailAction(err));
        })
      );
    })
  ));
}
